var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8997 35.1848C15.6851 35.1849 15.4753 35.1213 15.2968 35.0021C15.1183 34.8828 14.9792 34.7133 14.8971 34.5151C14.8149 34.3168 14.7934 34.0986 14.8353 33.8881C14.8772 33.6776 14.9806 33.4842 15.1324 33.3325L35.1841 13.2807C35.3876 13.0772 35.6636 12.9629 35.9514 12.9629C36.2392 12.9629 36.5153 13.0772 36.7188 13.2807C36.9223 13.4842 37.0366 13.7603 37.0366 14.0481C37.0366 14.3359 36.9223 14.6119 36.7188 14.8154L16.6671 34.8671C16.5664 34.968 16.4468 35.048 16.3151 35.1026C16.1834 35.1571 16.0422 35.185 15.8997 35.1848Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9514 35.1848C35.8088 35.185 35.6677 35.1571 35.536 35.1026C35.4043 35.048 35.2847 34.968 35.184 34.8671L15.1323 14.8154C14.9288 14.6119 14.8145 14.3359 14.8145 14.0481C14.8145 13.7603 14.9288 13.4842 15.1323 13.2807C15.3358 13.0772 15.6118 12.9629 15.8996 12.9629C16.1875 12.9629 16.4635 13.0772 16.667 13.2807L36.7187 33.3325C36.8705 33.4842 36.9739 33.6776 37.0158 33.8881C37.0576 34.0986 37.0361 34.3168 36.954 34.5151C36.8719 34.7133 36.7328 34.8828 36.5543 35.0021C36.3758 35.1213 36.166 35.1849 35.9514 35.1848Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.3baf3ab2ca4431d8b16a9b1b96168dbc.svg";
export { ForwardRef as ReactComponent };